import {
  Card,
  CardHeader,
  CardBody,
  Text,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  TableContainer,
  Flex,
  Input,
} from "@chakra-ui/react";
import { BrlCurrencyFormatter } from "@/utils/BrlCurrencyFormatter";
import { formatDateWithNoHours } from "@/utils/formatDateWithNoHours";
import { PropostaFinanceira } from "@/models/consignado/propostaFinanceira.model";

export interface BMPDataCardProps {
  proposal: PropostaFinanceira;
  editedValues: {
    dataPagamentoBanco: string;
    quantidadeParcelaBanco: number;
    valorLiberadoBanco: number;
  };
  editingFields: {
    dataPagamentoBanco: boolean;
    quantidadeParcelaBanco: boolean;
    valorLiberadoBanco: boolean;
  };
  monetaryInputs: {
    valorLiberadoBanco: string;
  };
  onChangeField: (field: "dataPagamentoBanco" | "quantidadeParcelaBanco" | "valorLiberadoBanco", value: string) => void;
}

const formatDateToInputValue = (value: string): string => {
  if (!value)
    return "";

  const date = new Date(value);

  if (!Number.isNaN(date.getTime()))
    return date.toISOString().slice(0, 10);

  return value.split(" ")[0] || "";
};

export default function BMPDataCard({
  proposal,
  editedValues,
  editingFields,
  monetaryInputs,
  onChangeField,
}: BMPDataCardProps) {

  return (
    <Card p={6} bg="white" borderRadius="lg" shadow="sm" borderWidth="2px" borderColor="gray.200">
      <CardHeader p={0} mb={6}>
        <Flex justify="space-between" align="center">
          <Text fontSize="md" fontWeight="bold" color="gray.700">
            DADOS BMP
          </Text>
          {/* <Text fontSize="md">
            CCB #{proposal.numeroCcb}
          </Text> */}
        </Flex>
      </CardHeader>
      <CardBody p={0}>
        <TableContainer>
          <Table variant="simple" size="sm">
            <Thead>
              <Tr>
                <Th fontSize="xs" color="gray.500" textTransform="uppercase">
                  CCB
                </Th>
                <Th fontSize="xs" color="gray.500" textTransform="uppercase">
                  <Flex alignItems="center" justifyContent="space-between" gap={2}>
                    Valor Liberado
                  </Flex>
                </Th>
                <Th fontSize="xs" color="gray.500" textTransform="uppercase" isNumeric>
                  <Flex alignItems="center" justifyContent="space-between" gap={2}>
                    Parcelas
                  </Flex>
                </Th>
                <Th fontSize="xs" color="gray.500" textTransform="uppercase">
                  <Flex alignItems="center" justifyContent="space-between" gap={2}>
                    Data Pagamento
                  </Flex>
                </Th>
              </Tr>
            </Thead>
            <Tbody>
              <Tr key={proposal.id}>
                <Td color="gray.800">
                  {proposal.numeroCcb}
                </Td>
                <Td color="gray.800">
                  {editingFields.valorLiberadoBanco
                    ? (
                      <Input
                        size="sm"
                        type="text"
                        inputMode="numeric"
                        value={monetaryInputs.valorLiberadoBanco}
                        onChange={(event) => onChangeField("valorLiberadoBanco", event.target.value)}
                      />
                    )
                    : BrlCurrencyFormatter(editedValues.valorLiberadoBanco)}
                </Td>
                <Td isNumeric color="gray.800">
                  {editingFields.quantidadeParcelaBanco
                    ? (
                      <Input
                        size="sm"
                        type="number"
                        value={String(editedValues.quantidadeParcelaBanco ?? "")}
                        onChange={(event) => onChangeField("quantidadeParcelaBanco", event.target.value)}
                      />
                    )
                    : editedValues.quantidadeParcelaBanco}
                </Td>
                <Td color="gray.700">
                  {editingFields.dataPagamentoBanco
                    ? (
                      <Input
                        size="sm"
                        type="date"
                        value={formatDateToInputValue(editedValues.dataPagamentoBanco)}
                        onChange={(event) => onChangeField("dataPagamentoBanco", event.target.value)}
                      />
                    )
                    : formatDateWithNoHours(editedValues.dataPagamentoBanco)}
                </Td>
              </Tr>
            </Tbody>
          </Table>
        </TableContainer>
      </CardBody>
    </Card>
  );
}

